import Header from "components/header";
import LoadingSpinner from "components/loading-spinner.tsx";
import LoginButtons from "components/login-buttons";
import { useEffect, useState } from "react";
import Headroom from "react-headroom";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { getPartnerGameState } from "state/slices/partner-game-slice";
import { setWalletIsStale } from "state/slices/wallet-slice";

const WALLET_POLL_INTERVAL = 3000; // 5 seconds

const PartnerGame = () => {
  const embedUrl = useAppSelector(getPartnerGameState).embedUrl;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!embedUrl) {
      navigate("/"); // Redirect to home if no embed URL
    }
  });

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(setWalletIsStale(true));
    }, WALLET_POLL_INTERVAL);

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <>
      <Headroom>
        <Header />
        <LoginButtons />
      </Headroom>

      {loading && <LoadingSpinner />}
      <>
        {embedUrl && (
          <iframe
            style={{
              width: "-webkit-fill-available",
              height: "calc(100dvh - 75px)",
              position: "fixed",
              top: 75,
            }}
            allow="clipboard-write; clipboard-read;"
            onLoad={() => setLoading(false)}
            src={embedUrl}
            title="partner game"
          ></iframe>
        )}
      </>
    </>
  );
};

export default PartnerGame;
